module.exports = __webpack_public_path__ + "static/media/voicemail.3419c885.svg";